import { observable } from "mobx";
import { AppConstants, Types } from "../../../common/APIConstants";
import moment from "moment";
import _ from "lodash";
import GainLossReferenceAPI from "../services/gainloss-reference-screen-service";
import GainLossListsScreenAPI from "../services/gainloss-lists-screen-service";
class GainLossReferenceDataStore {
  @observable screenRowData = {
    ReferenceData: [],
  };
  @observable rowData = [];
  @observable productsData = [];
  @observable screenColumnDefinitions = {
    GainLossReferenceScreen: [],
  };
  @observable productColumnDefinitions = {
    GainLossProductScreen: [],
  };
  @observable headerDetails = {
    jurisdictionDpDwnList: [],
  };
  @observable hasScreenData = false;
  @observable selectedData = [];
  @observable productSelectedData = [];

  @observable selectedJurisdiction = [];

  @observable types = [];
  @observable division = [];
  @observable system = [];
  @observable subSystem = [];
  @observable products = [];

  @observable referenceDataSaved = true;
  @observable productDataSaved = true;

  @observable isCopy = false;

  getHeaderData = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const { data } = await GainLossReferenceAPI.getReferenceHeaderData();
      this.headerDetails.jurisdictionDpDwnList = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
    }
  };
  resetReferenceData = () => {
    this.screenRowData.ReferenceData = [];
    this.hasScreenData = false;
  };
  getScreenData = async (currentScreen, jurisdictionTxt, CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    this.screenRowData.ReferenceData = [];
    this.rowData = [];
    this.selectedData = [];
    try {
      let requestObj = {
        jurisdiction: jurisdictionTxt,
      };
      const { data } = await GainLossReferenceAPI.getReferenceScreenData(
        requestObj
      );
      const referenceData = data?.map((item) => ({
        ...item,
        isActive: item.isActive ? "Active" : "Inactive",
      }));
      this.screenRowData.ReferenceData = referenceData;
      this.rowData = referenceData;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Data not available for selected jurisdiction"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  getProductsData = async (
    currentScreen,
    subsystemTxt,
    effectiveStartDate,
    effectiveEndDate,
    CommonStore
  ) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    this.productsData = [];
    this.productSelectedData = [];
    try {
      let requestObj = {
        SubSystem: subsystemTxt,
        EffectiveStartDate: effectiveStartDate,
        EffectiveEndDate: effectiveEndDate,
      };
      const { data } = await GainLossReferenceAPI.getProducts(requestObj);
      const productsdata = data?.map((item) => ({
        ...item,
        isActive: item.isActive ? "Active" : "Inactive",
      }));
      this.productsData = productsdata;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Data not available for selected Jurisdiction"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  geEntityName = async (entityType) => {
    const requestData = {
      jurisdiction: this.selectedJurisdiction,
      entityType: entityType,
    };
    const { data } = await GainLossListsScreenAPI.getEntityList(requestData);
    return data
      .filter((entity) => entity.isActive)
      .map((entity) => entity.entityName);
  };
  setProductColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;
        this.productColumnDefinitions[child.screen.name] = [];
        this.productColumnDefinitions[child.screen.name] =
          this.getProductsColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Data not available for the selected SubSystem"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;

        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenColumnDefinitions[child.screen.name] =
          this.getAllColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: "text",
        hide: column.hidden,
        isEditableCol: column.readOnly,
        width: column.width ? column.width : 200,
        required: column.required,

        keyCreator: (params) => {
          return this.getValueFomatter(params, column, screen)
            ? this.getValueFomatter(params, column, screen)
            : params.value;
        },
        editable: (params) => {
          const firstAug2024 = moment('08/01/2024').format()
          const effectiveStartDate = moment(params.data.effectiveStartDate).format()

          /* For New Record */
          if (params.node.data.isNewRow && params.node.data.jurisdiction === 'Plains - North'
            && params.data.type === 'Facility' && ['gainLossM3', 'maxGainLossM3',
              'gainLossPercentage'].includes(column.name)) {
            return false
          }
          if (params.node.data.isNewRow && params.node.data.jurisdiction === 'Plains - North'
            && params.data.type === 'Pipeline' && !['gainLossM3', 'maxGainLossM3',
              'gainLossPercentage'].includes(column.name) && column.name === 'tolerance') {
            return false
          }

          /* For Old Records */
          if ((params.node.data.jurisdiction === 'Plains - North') &&
            (effectiveStartDate < firstAug2024) &&
            ['gainLossM3', 'maxGainLossM3', 'gainLossPercentage'].includes(column.name)) {
            return false
          }
          if ((params.node.data.jurisdiction === 'Plains - North') && (effectiveStartDate >= firstAug2024) &&
            params.data.type === 'Facility' && ['gainLossM3', 'maxGainLossM3',
              'gainLossPercentage'].includes(column.name)) {
            return false
          }
          if ((params.node.data.jurisdiction === 'Plains - North') && (effectiveStartDate >= firstAug2024) &&
            params.data.type === 'Pipeline' && column.name === 'tolerance' &&
            !['gainLossM3', 'maxGainLossM3',
              'gainLossPercentage'].includes(column.name)) {
            return false
          }
          
          if (params.node.data.isNewRow && !column.nonDataEntryField && !['createdBy', 'createdDate',
            'updatedBy', 'updatedDate', 'effectiveEndDate'].includes(column.name)) {
            return true
          }
          return screen.canEditRow && !column.readOnly
        },

        cellClassRules: {
          "highlight-cell": (params) => {
            return this.getIsEditable(params, column, screen);
          },
          "grid-cell-custom": (params) => {
            return params.data ? true : false;
          },
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) =>
          this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => {
          return this.getValueFomatter(params, column, screen);
        },

        //for cell colors
        cellStyle: (params) => {
          const firstAug2024 = moment('08/01/2024').format()
          const effectiveStartDate = moment(params.data.effectiveStartDate).format()
          
          if (column.readOnly && !params.node.data.isNewRow) {
            return { backgroundColor: "LightGray" };
          }
          if ((params.node.data.jurisdiction === 'Plains - North') &&
            (effectiveStartDate < firstAug2024) &&
            ['gainLossM3', 'maxGainLossM3', 'gainLossPercentage'].includes(column.name)) {
            return { backgroundColor: "LightGray" };
          }
          if ((params.node.data.jurisdiction === 'Plains - North') && (effectiveStartDate >= firstAug2024) &&
            params.data.type === 'Facility' && ['gainLossM3', 'maxGainLossM3',
              'gainLossPercentage'].includes(column.name)) {
            return { backgroundColor: "LightGray" };
          }
          if ((params.node.data.jurisdiction === 'Plains - North') && (effectiveStartDate >= firstAug2024) && params.data.type === 'Pipeline' && column.name === 'tolerance') {
            return { backgroundColor: "LightGray" };
          }
          if (column.required && params.node.data.isNewRow) {
            return { border: "1px solid red" };
          }
        },
      });
    });
    return gridColumns;
  };
  getProductsColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: "text",
        hide: column.hidden,
        isEditableCol: column.readOnly,
        width: column.width ? column.width : 200,
        required: column.required,

        keyCreator: (params) => {
          return this.getValueFomatter(params, column, screen)
            ? this.getValueFomatter(params, column, screen)
            : params.value;
        },
        editable: (params) =>
          params.node.data.isNewRow &&
          !column.nonDataEntryField &&
          column.name !== "subSystem" &&
          column.name !== "effectiveStartDate" &&
          column.name !== "createdBy" &&
          column.name !== "createdDate" &&
          column.name !== "updatedBy" &&
          column.name !== "updatedDate"
            ? true
            : screen.canEditRow && !column.readOnly,

        cellClassRules: {
          "highlight-cell": (params) => {
            return this.getIsEditable(params, column, screen);
          },
          "grid-cell-custom": (params) => {
            return params.data ? true : false;
          },
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) =>
          this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => {
          return this.getValueFomatter(params, column, screen);
        },

        //for cell colors
        cellStyle: (params) => {
          if (column.readOnly && !params.node.data.isNewRow) {
            return { backgroundColor: "LightGray" };
          }
          if (column.required && params.node.data.isNewRow) {
            return { border: "1px solid red" };
          }
        },
      });
    });
    return gridColumns;
  };

  getIsEditable(params, column) {
    const firstAug2024 = moment('08/01/2024').format()
    const effectiveStartDate = moment(params.data.effectiveStartDate).format()
    if (params.data.productTxt !== "") {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      if (moment(params.data["DateTxt"]) < moment(date)) {
        return false;
      }
    }
    if ((params.node.data.jurisdiction === 'Plains - North') &&
      (effectiveStartDate < firstAug2024) &&
      ['gainLossM3', 'maxGainLossM3', 'gainLossPercentage'].includes(column.name)) {
      return false
    }
    if ((params.node.data.jurisdiction === 'Plains - North') &&
      (effectiveStartDate >= firstAug2024) &&
      params.data.type === 'Facility' && ['gainLossM3', 'maxGainLossM3',
        'gainLossPercentage'].includes(column.name)) {
      return false;
    }
    if ((params.node.data.jurisdiction === 'Plains - North') &&
      (effectiveStartDate >= firstAug2024) && params.data.type === 'Pipeline' &&
      column.name === 'tolerance') {
      return false
    }
    if (this.getIsDataReadOnly() || !params.data) return false;
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {
    return false;
  }
  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return "booleanCellEditor";
      case Types.DATETIME:
        return "dateTimeFormatter";
      case Types.DATE:
        return "dateFormatter";
      case Types.DECIMAL:
        if (["materiality", "gainLossBarrels", "maxGainLossBarrels", "gainLossM3", 
          "maxGainLossM3"].includes(column.name)){
          return "decimalFormatter";
        }
        else return "decimalFormatter3Digits";
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.datetime:
        return "dateTimeFormatter";
      case Types.date:
        return "dateFormatter";
    }
  }
  getCellEditorParams = (column, params) => {
    switch (column.type) {
      case Types.DROPDOWN:
        if (column.name === "isActive")
          return {
            values: [
              { label: "Active", value: "Active" },
              { label: "Inactive", value: "Inactive" },
            ],
          };
        else if (column.name === "uom") {
          if (this.selectedJurisdiction === "Plains - North")
            return {
              values: [
                { label: "M3", value: "M3" },
                { label: "USG", value: "USG" },
              ],
            };
          else {
            return {
              values: [{ label: "BBL", value: "BBL" }],
            };
          }
        } else if (column.name === "jurisdiction") {
          if (this.selectedJurisdiction === "Plains - North")
            return {
              values: [{ label: "Plains - North", value: "Plains - North" }],
            };
          else {
            return {
              values: [{ label: "Plains - South", value: "Plains - South" }],
            };
          }
        } else if (column.name === "division") {
          return {
            values: this.division?.map((item) => {
              return { label: item, value: item };
            }),
          };
        } else if (column.name === "system") {
          return {
            values: this.system?.map((item) => {
              return { label: item, value: item };
            }),
          };
        } else if (column.name === "subSystem") {
          return {
            values: this.subSystem?.map((item) => {
              return { label: item, value: item };
            }),
          };
        } else if (column.name === "type") {
          return {
            values: this.types?.map((item) => {
              return { label: item, value: item };
            }),
          };
        } else if (column.name === "product") {
          return {
            values: this.products?.map((item) => {
              return { label: item, value: item };
            }),
          };
        } else
          return {
            values: column.refLookupData?.lookupValues.values,
            isPopup: true,
          };
    }
  };

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(
          column.refLookupData.lookupValues,
          params.value
        );
      }
    }
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }
  saveData = async (CommonStore) => {
    this.referenceDataSaved = false;
    CommonStore.toggleLoader();
    const toAddUpdate = this.selectedData;

    const screenCols = this.screenColumnDefinitions["GainLossReferenceScreen"];

    const requiredColumns = screenCols.filter((x) => x.required);
    let requiredValidated = true;
    for (let col of requiredColumns) {
      if (toAddUpdate.length > 0) {
        const zeroValueRequiredFields = ['tolerance', 'offset', 'materiality', 
          'gainLossBarrels', 'gainLossPercentage', 'maxGainLossBarrels', 'gainLossM3', 
          'maxGainLossM3'
        ]
        if(zeroValueRequiredFields.includes(col.field) && 
          [null, ''].includes(toAddUpdate[0][col?.field])){
            toAddUpdate[0][col?.field] = 0.0
        }
        if (
          toAddUpdate[0][col?.field] === null ||
          toAddUpdate[0][col?.field] === ""
        ) {
          requiredValidated = false;
          break;
        }
      }
    }
    if (toAddUpdate.length === 0 && this.isCopy) {
      window.toastr.error(AppConstants.TOASTER_ERROR_DUPLICATE_TEXT);
      CommonStore.toggleLoader();
    } else if (!requiredValidated || toAddUpdate.length === 0) {
      window.toastr.error(AppConstants.TOASTER_ERROR_REQUIRED_TEXT);
      CommonStore.toggleLoader();
    } else {
      try {
        const addUpdateData = toAddUpdate.map((item) => {
          delete item.isNewRow;
          delete item.Copy;
          item.isActive =
            item?.isActive === "Active" || item?.isActive == true
              ? true
              : false; //this is to set isActive col value to true for Active and false for in
          item.subSystem = item.subSystem;
          return item;
        });
        let requestObj = {
          ReferenceDataRequests: addUpdateData,
        };
        const { data } = await GainLossReferenceAPI.saveReferenceScreenData(
          requestObj
        );

        window.toastr.success("Reference Data Saved Sucessfully!");
        CommonStore.toggleLoader();

        this.selectedData = [];

        this.referenceDataSaved = true;
      } catch (error) {
        console.log("error:", error.response.data);
        if (
          error.response.data.includes("Violation of UNIQUE KEY constraint")
        ) {
          window.toastr.error(
            AppConstants.GAINLOSSREFERENCETOASTER_ERROR_DUPLICATE_TEXT
          );
        } else if (
          error.response.data.includes(
            "Effective Start Date can only be the first day of the month for an existing SubSystem"
          )
        ) {
          window.toastr.error(
            AppConstants.GAINLOSS_TOASTER_ERROR_EFFECTIVESTARTDATE_FIRST_DAY_TEXT
          );
        } else
          window.toastr.error(
            AppConstants.GAINLOSSREFERENCETOASTER_ERROR_SAVE_TEXT
          );
        CommonStore.toggleLoader();
      }
    }
  };

  saveProductData = async (CommonStore) => {
    this.productDataSaved = false;
    CommonStore.toggleLoader();
    const toAddUpdate = this.productSelectedData;
    const screenCols = this.screenColumnDefinitions["GainLossReferenceScreen"];

    const requiredColumns = screenCols.filter((x) => x.required);
    let requiredValidated = true;
    for (let col of requiredColumns) {
      if (toAddUpdate.length > 0) {
        if (toAddUpdate[0][col?.field] === null) {
          requiredValidated = false;
          break;
        }
      }
    }
    if (!requiredValidated || toAddUpdate.length === 0) {
      window.toastr.error(AppConstants.TOASTER_ERROR_REQUIRED_TEXT);
      CommonStore.toggleLoader();
    } else {
      try {
        const addUpdateData = toAddUpdate.map((item) => {
          delete item.isNewRow;
          item.isActive =
            item?.isActive === "Active" || item?.isActive == true
              ? true
              : false; //this is to set isActive col value to true for Active and false for inactive
          return item;
        });
        let requestObj = {
          ProductsRequests: addUpdateData,
        };
        const { data } = await GainLossReferenceAPI.saveProductData(requestObj);
        window.toastr.success("Products Saved Sucessfully!");
        CommonStore.toggleLoader();

        this.productSelectedData = [];
        this.productDataSaved = true;
      } catch (error) {
        console.log("error:", error.response.data);
        if (
          error.response.data.includes("Violation of UNIQUE KEY constraint")
        ) {
          window.toastr.error(
            AppConstants.GAINLOSSPRODUCTTOASTER_ERROR_DUPLICATE_TEXT
          );
        } else
          window.toastr.error(
            AppConstants.GAINLOSSPRODUCTTOASTER_ERROR_SAVE_TEXT
          );
        CommonStore.toggleLoader();
      }
    }
  };
}
export default new GainLossReferenceDataStore();
